import { render, staticRenderFns } from "./ourSpace.vue?vue&type=template&id=fb243ed2&scoped=true&"
import script from "./ourSpace.vue?vue&type=script&lang=js&"
export * from "./ourSpace.vue?vue&type=script&lang=js&"
import style0 from "./ourSpace.vue?vue&type=style&index=0&id=fb243ed2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb243ed2",
  null
  
)

export default component.exports